import { ARTICLE_PATHS } from "./articleUrls"

export const ADDITIONAL_REQUIREMENTS = {
  // Experience Credits Card (shown for all users)
  EXPERIENCE_CREDITS: {
    id: "experience_credits",
    title: "Understanding Experience Credits",
    description:
      "Experience credits are calculated based on your specific education and industry work, including your current job. Forecast your credits now so you can ensure you meet the requirements for PGA Membership by the end of the program.",
    linkText: "Learn More",
    linkUrl: ARTICLE_PATHS.EXPERIENCE_CREDITS,
  },

  // Playing Ability Test Card (shown only when PAT is incomplete)
  PAT: {
    id: "playing_ability_test",
    title: "Playing Ability Test",
    description:
      "Congratulations, you have a qualifying score on your PAT. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.",
    primaryLinkText: "Find a PAT",
    secondaryLinkText: "View Guide",
    secondaryLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST,
  },
}
